import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import {
  acceptAnalyticsConsent,
  initPostHog,
  rejectAnalyticsConsent,
} from '../analytics/posthog'
import { initMetaPixel } from '../analytics/meta-pixel'
import { getAnalyticsConsent } from '../analytics/consent'
import './cookie-consent.css'

/**
 * Compact analytics consent banner — shown until the visitor chooses Accept or Reject.
 * Strictly necessary cookies (theme preference) are not gated by this banner.
 */
export function CookieConsentBanner() {
  const [visible, setVisible] = useState(false)
  const [manageOpen, setManageOpen] = useState(false)

  useEffect(() => {
    // Load SDK only when prior consent exists or debug/prod config allows prep.
    // Rejected / undecided visitors do not download PostHog until Accept.
    const consent = getAnalyticsConsent()
    if (consent === 'accepted') {
      void initPostHog()
      initMetaPixel()
    }
    setVisible(consent === null)
  }, [])

  useEffect(() => {
    const onHash = () => {
      if (window.location.hash === '#cookie-settings') {
        setManageOpen(true)
        setVisible(true)
      }
    }
    onHash()
    window.addEventListener('hashchange', onHash)
    return () => window.removeEventListener('hashchange', onHash)
  }, [])

  if (!visible) return null

  return (
    <div className="pp-consent" role="dialog" aria-label="Cookie preferences" aria-live="polite">
      <div className="pp-consent__inner">
        <div className="pp-consent__copy">
          <p className="pp-consent__title">Analytics cookies</p>
          <p className="pp-consent__text">
            We use optional analytics (PostHog) and advertising measurement (Meta Pixel) to
            understand aggregate public-website usage and campaign performance. No passwords,
            account data, or form contents are collected. You can change this anytime.
          </p>
          <p className="pp-consent__links">
            <Link to="/cookies">Cookie Policy</Link>
            {' · '}
            <Link to="/privacy">Privacy Policy</Link>
            {manageOpen ? (
              <>
                {' · '}
                <button
                  type="button"
                  className="pp-consent__text-btn"
                  onClick={() => {
                    void rejectAnalyticsConsent()
                    setVisible(false)
                    setManageOpen(false)
                  }}
                >
                  Withdraw analytics consent
                </button>
              </>
            ) : null}
          </p>
        </div>
        <div className="pp-consent__actions">
          <button
            type="button"
            className="wt-btn wt-btn--ghost"
            onClick={() => {
              void rejectAnalyticsConsent()
              setVisible(false)
              setManageOpen(false)
            }}
          >
            Reject non-essential
          </button>
          <button
            type="button"
            className="wt-btn wt-btn--primary"
            onClick={() => {
              void acceptAnalyticsConsent()
              setVisible(false)
              setManageOpen(false)
            }}
          >
            Accept analytics
          </button>
        </div>
      </div>
    </div>
  )
}
